import React, { useState } from "react";
import openMenuIcon from "./../../assests/img/open-menu-icon.svg";
import closeMenuIcon from "./../../assests/img/close-menu-icon.svg";
import HeaderItem from "./HeaderItem";
import { sidebarMenu } from "./MenuHelper";
import MenuItem from "./MenuItem";

const Sidebar = () => {
  const [showMenu, setShowMenu] = useState<boolean>(true);
  const [selectedItem, setSelectedItem] = useState<object | null>(
    sidebarMenu[0].menuItems[1]
  );
  const handleClick = (): void => {
    setShowMenu((prevShowMenu) => !prevShowMenu);
  };

  return (
    <div
      id="sidebar-container"
      className={`tw-bg-[#fff] tw-min-h-full tw-border tw-border-r tw-max-h-full tw-overflow-y-auto tw-no-scrollbar tw-pt-3 ${
        showMenu ? "tw-w-60" : "tw-w-16"
      } tw-transition-width tw-duration-100 `}
    >
      <button
        id="sidebar-toggle-btn"
        className={`tw-block tw-absolute ${
          showMenu ? "tw-left-56" : "tw-left-12"
        } tw-top-0 tw-transition-width tw-duration-100 tw-bg-white tw-z-10 tw-p-0 tw-m-0 tw-h-min`}
        onClick={handleClick}
      >
        <img
          id="sidebar-toggle-icon"
          className={`tw-w-6 tw-aspect-square`}
          src={showMenu ? closeMenuIcon : openMenuIcon}
          alt="menuIcon"
        />
      </button>
      <ul id="sidebar-menu-list">
        <>
          {sidebarMenu.map((header, index) => (
            <React.Fragment key={index}>
              {header.headerName !== "" ? (
                <HeaderItem 
                  id={`sidebar-header-${index}`}
                  key={header.headerName + index} 
                  label={header.headerName} 
                  show={showMenu} 
                />
              ) : null}
              {header.menuItems.map((menu, key) => {
                return (
                  <MenuItem
                    id={`sidebar-menu-item-${index}-${key}`}
                    key={key}
                    path={menu.path}
                    iconSrc={menu.icon}
                    filledIconSrc={menu.filledIcon}
                    label={menu.menuName}
                    show={showMenu}
                    menu={menu}
                    selectedItem={selectedItem}
                    setSelectedItem={setSelectedItem}
                    matchPath={menu.matchPath}
                  />
                );
              })}
            </React.Fragment>
          ))}
        </>
      </ul>
    </div>
  );
};

export default Sidebar;
